<template>
  <div
    class="enroll-select"
    :style="{ maxHeight: `${prop.maxHeight}px`, width: `${prop.width}px` }"
  >
    <slot>
      <div
        v-for="(item, index) in options"
        :key="index"
        class="select-item"
        :style="{ height: `${prop.itemHeight}px` }"
      >
        <div
          class="content"
          @mousedown="() => selectItem(item)"
          v-html="item.name"
        ></div>
      </div>
    </slot>
  </div>
</template>

<script>
export default {
  props: {
    prop: {
      type: Object,
      default: function () {
        return {
          maxHeight: 276,
          itemHeight: 53,
          // width: 466
        };
      },
    },
    options: {
      tyep: Array,
      default: function () {
        return [];
      },
    },
  },

  methods: {
    selectItem(item) {
      this.$emit('change', item);
    },
  },
};
</script>

<style lang="scss" scoped>
.enroll-select {
  position: absolute;
  z-index: 3333;
  width: 100%;
  overflow: auto;
  background: #fff;
  border: solid 2px #dbdada;
  border-right: solid 2px #dbdada;
  .select-item {
    display: flex;
    align-items: center;
    padding: 10px 32px;
    color: #383333;
    font-size: 24px;
    .content {
      width: 100%;
    }
    &:hover {
      background: #f4f4f4;
    }
    &:active {
      background: #f4f4f4;
    }
  }
}
</style>
